import { jsx as _jsx } from "react/jsx-runtime";
//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
// Material ui Imports
import { TextField } from "@mui/material";
// Location component is used for bespoke styling
export var DropPoint;
(function (DropPoint) {
    DropPoint["DROP_CANVAS"] = "drop canvas";
    DropPoint["DROP_TIMELINE"] = "drop timeline=";
})(DropPoint || (DropPoint = {}));
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// Only display layouts in pages
export default function VTCreatorDropContainer(_a) {
    //-------------------------------------------------------------------------------------------------
    // ## HOOKS ##
    var handleMediaDropped = _a.handleMediaDropped, currentlyDragging = _a.currentlyDragging, location = _a.location, bottomDrawWidth = _a.bottomDrawWidth;
    //-------------------------------------------------------------------------------------------------
    // ## USE SELECTOR ##
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##
    //-------------------------------------------------------------------------------------------------
    // ## USE EFFECTS ##
    //-------------------------------------------------------------------------------------------------
    // ## CUSTOM FUNCTIONS ##
    //-------------------------------------------------------------------------------------------------
    // ## RETURN ##
    // Drop container for the creator page
    return (_jsx(TextField, { value: "", onChange: function (e) { return handleMediaDropped(currentlyDragging); }, variant: "standard", sx: {
            position: "absolute",
            top: 0.5,
            right: 0,
            zIndex: 5,
            backgroundColor: "rgba(0,0,0,0)",
            border: "3px solid #7315ce",
            borderRadius: "15px",
            // Styling based on location; dynamically calc height for the canvas and timeline panel
            width: location === DropPoint.DROP_CANVAS
                ? "calc(100% - " + 100 + "px)"
                : "100%",
            // Styling based on location; dynamically calc width for the canvas and timeline panel
            height: location === DropPoint.DROP_CANVAS
                ? "100%"
                : "calc(100% - " + 4 + "px)",
        }, fullWidth: true, inputProps: {
            style: {
                // Set the content width; effects functionality not styling
                height: location === DropPoint.DROP_CANVAS
                    ? "calc(100vh - " +
                        85.5 +
                        "px - " +
                        bottomDrawWidth +
                        "px)"
                    : bottomDrawWidth - 10,
                color: "rgba(0,0,0,0)",
                border: "none",
            },
            disableUnderline: true,
        }, multiline: true }));
}
